import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import Currency from 'components/currency';
import { priceForCartEntry } from 'utils/menu/price';

import { IIsOffer, IPrice } from '../types';

interface IHidden {
  show: boolean;
}

const PriceContainer = styled.div`
  display: flex;
  align-items: baseline;
`;

const FancyText = styled.p<IHidden>`
  color: ${Styles.color.primary};
  font-family: ${Styles.fontFamily.base};
  margin: 0.5rem 0.25rem;
  opacity: ${p => (p.show ? 1 : 0)};
`;

const CartItemPrice = styled.span<IIsOffer>`
  margin: 0;
  white-space: nowrap;
  font-size: 1rem;
  color: ${Styles.color.secondary};
  ${p =>
    p.isOffer
      ? `
      color: ${Styles.color.pricing};
      font-weight: ${Styles.fontWeight.heavy};
      `
      : ''}
`;

const Price: React.FC<IPrice> = ({ item, isOffer, rewardApplied }) => {
  const { formatMessage } = useIntl();
  return (
    <PriceContainer>
      <FancyText show={!!rewardApplied}>{formatMessage({ id: 'reward' })}</FancyText>
      <CartItemPrice isOffer={isOffer} id={`cart-price-${item.cartId || item._id}`}>
        <Currency amount={priceForCartEntry(item)} />
      </CartItemPrice>
    </PriceContainer>
  );
};

export default Price;
